/**
 * Mission Query Keys
 *
 * Centralized query key factory for React Query cache management
 * Following React Query best practices for key management
 */

import type { MissionListParams } from './mission.api';

export const missionQueryKeys = {
    // Base key for all mission-related queries
    all: ['missions'] as const,

    // List queries
    lists: () => [...missionQueryKeys.all, 'list'] as const,
    list: (params?: MissionListParams) => [...missionQueryKeys.lists(), params] as const,

    // Detail queries
    details: () => [...missionQueryKeys.all, 'detail'] as const,
    detail: (id: string) => [...missionQueryKeys.details(), id] as const,
};
